import { useState, useEffect } from "react";

export const SplashScreen = () => {
  const [phase, setPhase] = useState("visible");

  useEffect(() => {
    const fadeTimer = setTimeout(() => setPhase("fading"), 1400);
    const removeTimer = setTimeout(() => setPhase("done"), 1900);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);

  if (phase === "done") return null;

  return (
    <div
      data-testid="splash-screen"
      className={`fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-[#0a0a09] transition-opacity duration-500 ${
        phase === "fading" ? "pointer-events-none" : ""
      }`}
      style={{ opacity: phase === "fading" ? 0 : 1 }}
    >
      <img
        src="/repair-3.jpg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full scale-105 object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a09]/85 via-[#0a0a09]/80 to-[#0a0a09]/95" />
      <div className="relative flex flex-col items-center px-6 text-center">
        <img
          src="/edt-crest.png"
          alt="EDT Claims Solution & Services"
          className="splash-crest h-28 w-auto sm:h-36"
        />
        <p className="font-display splash-crest mt-6 text-lg tracking-wide text-[#f2ede3] sm:text-2xl" style={{ animationDelay: "0.15s" }}>
          EDT Claims <span className="text-[#c9a24b]">Solution &amp; Services</span>
        </p>
        <div className="splash-crest mt-5 h-px w-16 bg-[#c9a24b]" style={{ animationDelay: "0.3s" }} />
      </div>
    </div>
  );
};
